export default __webpack_public_path__ + "static/media/MVRDV-slide-06.59834406.jpg";